<span
  class="mat-mdc-optgroup-label"
  role="presentation"
  [class.mdc-list-item--disabled]="disabled"
  [id]="_labelId">
  <span class="mdc-list-item__primary-text">{{ label }} <ng-content></ng-content></span>
</span>

<ng-content select="mat-option, ng-container"></ng-content>
